/**
 * This object matches keys of a faq item to its translation key in vue-i18n.
 * Therefore it is important to keep them in sync
 */
export const faqItems = {
  smartRoute: 'smartRoute',
  transitVisa: 'transitVisa',
  selfTransfer: 'selfTransfer',
  emptyBaggage: 'emptyBaggage',
  guarantorAirline: 'guarantorAirline',
} as const;
